import React, { useContext, useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import Button from '../../../components/Button';
import moment from 'moment';
import Modal from './extraModal/AchieveModal'
import { arrayForSelect } from '../../../utils/arrayForSelect';
import { useSelector } from 'react-redux';
import CustomSelect from '../../../components/CustomSelect';


export default function AwardAndPunishment() {

  const { allForms, addMode, studentTabData, updateInitialValues, trackDeletion } = useContext(StudentsContext)

  const { values, setFieldValue, setValues } = allForms

  const { penalties: awardData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [selectedItem, setSelectedItem] = useState(null)
  const { schoolYears } = useSelector(state => state.common)
  const [year, setYear] = useState(null)

  useEffect(() => {
    const dataJson = JSON.stringify(awardData)
    if (!addMode && awardData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        penalties: [...awardData]
      }))
      if (updateInitialValues) {
        updateInitialValues('penalties', awardData)
      }
    }
  }, [awardData, addMode, setValues, updateInitialValues])

  const handleYearChange = (name, value) => {
    setYear(value)
  }

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const handleSaveItem = (itemData) => {
    if (selectedItem === 'add' || !itemData.xp_pf_py) {
      const newItem = {
        ...itemData,
        xp_pf_py: `new_${Date.now()}`
      }
      setFieldValue('penalties', [...(values.penalties || []), newItem])
    } else {
      const updated = (values.penalties || []).map(item =>
        item.xp_pf_py === itemData.xp_pf_py ? itemData : item
      )
      setFieldValue('penalties', updated)
    }
    setTimeout(() => allForms.handleSubmit(), 0)
    closeModal()
  }

  const handleDeleteItem = (itemId) => {
    if (!String(itemId).startsWith('new_')) {
      trackDeletion('penalties', itemId)
    }
    const filtered = (values.penalties || []).filter(item => item.xp_pf_py !== itemId)
    setFieldValue('penalties', filtered)
  }

  const renderLi = (item) => {
    const { xp_pf_py, datepenatly, reason_vid, reason, whocreate, whencreate, whogave, cleared } = item
    return (
      <tr key={xp_pf_py} onClick={openModal(item)}>
        <td>{datepenatly ? moment(datepenatly).format('DD.MM.YYYY') : ''}</td>
        <td>{reason_vid || ''}</td>
        <td>{reason || ''}</td>
        <td>{whocreate || ''}</td>
        <td>{whencreate ? moment(whencreate).format('DD.MM.YYYY') : ''}</td>
        <td>{whogave || ''}</td>
        <td>{cleared ? 'Да' : 'Нет'}</td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem === 'add' ? {} : selectedItem}
          height={'430px'}
          addMode={selectedItem === 'add'}
          tabType='penalties'
          onSave={handleSaveItem}
          onDelete={handleDeleteItem}
        />
      }

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Учебный год'
            valuesName="year"
            options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
            width='120px'
            value={year}
            setFieldValue={handleYearChange}
          />
        </div>
        <Table className={styles.table} >
          <thead>
            <tr>
              <th>Дата</th>
              <th>Вид</th>
              <th>Причина</th>
              <th>Кто создал</th>
              <th>Когда создал</th>
              <th>Кем поощрен/наказан</th>
              <th>Снято</th>
            </tr>
          </thead>
          <tbody>
            {values.penalties?.map(renderLi)}
          </tbody>
        </Table>
        <br />
        <Button onClick={openModal('add')}>Добавить</Button>
      </div>
    </div>
  )
}

